import InsuranceVOB from './InsuranceVOB';

export default InsuranceVOB;
